import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';

/** Image settings preset `<Icon>` component. */
export const Icon = ({ className, ...props }: Props): ReactElement => (
  <svg
    className={twMerge('h-[75px] w-[75px] fill-current', className)}
    role='img'
    viewBox='0 0 75 75'
    {...props}
  >
    <path d='M63.9 46H25.4c-2.7-2.5-6.3-4-10.2-4C7 41.9.2 48.6.2 56.8s6.8 15 15 15c4 0 7.5-1.5 10.2-4h38.4c6 0 10.9-4.9 10.9-10.9.1-6.1-4.8-10.9-10.8-10.9zM15.2 70.2c-7.4 0-13.4-6-13.4-13.4s6-13.4 13.4-13.4 13.4 6 13.4 13.4-6 13.4-13.4 13.4zm48.7-4h-37c2.1-2.6 3.3-5.8 3.3-9.4 0-3.5-1.2-6.8-3.3-9.4h37c5.2 0 9.4 4.2 9.4 9.4-.1 5.2-4.3 9.4-9.4 9.4zM11.1 29h38.4c2.7 2.5 6.3 4 10.2 4 8.2 0 14.9-6.7 14.9-14.9S68 3.2 59.8 3.2c-4 0-7.5 1.5-10.2 4H11.1C5.1 7.2.2 12.1.2 18.1S5.1 29 11.1 29zM59.8 4.8c7.4 0 13.4 6 13.4 13.4s-6 13.4-13.4 13.4-13.4-6-13.4-13.4 6-13.4 13.4-13.4zm-48.7 4h37c-2.1 2.6-3.3 5.8-3.3 9.4s1.2 6.8 3.3 9.4h-37c-5.2 0-9.4-4.2-9.4-9.4S6 8.8 11.1 8.8z' />
  </svg>
);
